import styled, { css } from 'vue-styled-components';

import { BLUE, CUSTOM_SCROLL, GRAY } from '@/styles/common.styled';
import {
    FLEX_CENTER_DIV,
    FLEX_DIV,
    FLEX_VERTICAL_CENTER_DIV,
} from '@/styles/common.styled.component';

export const Wrapper = styled.div`
    display: flex;
    flex-direction: column;

    height: 340px;
`;

export const SearchHeader = styled(FLEX_VERTICAL_CENTER_DIV)`
    height: 56px;
    padding: 12px;
    position: relative;
    justify-content: space-between;
    border-bottom: 1px solid var(--color-gray-30);

    .search-bar {
        background-color: ${GRAY(10)};
        border: 1px solid ${GRAY(10)};
        padding: 0 35px 0 15px;
        color: ${GRAY(100)};

        &:focus {
            border: 1px solid ${BLUE(60)};
            background-color: #fff;
        }
        &::placeholder {
            color: ${GRAY(30)};
        }
    }

    .icon-wrapper {
        position: absolute;
        display: flex;
        justify-content: center;
        align-items: center;
        height: 30px;
        right: 25px;

        svg {
            fill: ${GRAY(30)};
        }
    }
`;

export const ResultWrapper = styled(FLEX_DIV)`
    flex: 1;
    overflow-y: auto;
    border-bottom: 1px solid var(--color-gray-30);

    .no-data {
        align-self: center;
        justify-self: center;

        margin: auto;
        color: ${GRAY(40)};
        font-size: 13px;
        font-weight: 500;
        white-space: pre-line;
        text-align: center;
    }
`;

export const ListWrapper = styled.ul`
    width: 100%;
    height: 100%;
    padding: 5px 0;

    display: flex;
    flex-direction: column;

    overflow-y: auto;
    list-style-type: none;
    ${CUSTOM_SCROLL}
`;

export const ItemWrapper = styled('li', {
    selected: Boolean,
    disabled: Boolean,
})`
    height: 36px;
    padding: 10px 16px;

    display: flex;
    align-items: center;
    gap: 8px;
    flex-wrap: nowrap;

    cursor: pointer;

    &:hover {
        background-color: var(--color-gray-10);
    }

    ${({ selected }) =>
        selected &&
        css`
            background-color: var(--color-gray-10);
            h1 {
                color: var(--color-blue-60);
            }
        `}

    ${({ disabled }) =>
        disabled &&
        css`
            cursor: not-allowed;
            opacity: 0.5;
        `}
`;

export const ItemTitle = styled.h1`
    font-size: 13px;
    font-weight: 400;

    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
`;

export const ButtonWrapper = styled(FLEX_VERTICAL_CENTER_DIV)`
    height: 56px;
    padding: 12px;
    justify-content: end;
    gap: 8px;

    button {
        height: 32px;
        padding: 9px 16px;
        font-size: 13px;
        font-weight: 500;

        &.unselect-btn {
            background-color: var(--color-gray-white);
            color: ${GRAY(100)};
            border: 1px solid ${GRAY(30)};
        }
    }
`;

export const Logo = styled(FLEX_CENTER_DIV)`
    flex-shrink: 0;

    &,
    & > * {
        width: 16px;
        height: 16px;
    }
`;
